document.addEventListener('DOMContentLoaded', function () {
  try {
    const dropdown = document.querySelector('.custom-dropdown');
    if(dropdown) {
      const selected = dropdown.querySelector('.dropdown-selected');
      const options = dropdown.querySelector('.dropdown-options');
      const optionItems = options.querySelectorAll('.dropdown-option');
      const filterLinks = document.querySelectorAll('.filter-link');
  
      selected.addEventListener('click', () => {
        try {
          options.style.display = options.style.display === 'block' ? 'none' : 'block';
        } catch (err) {
          console.error('Error toggling dropdown options:', err);
        }
      });
  
      optionItems.forEach(option => {
        option.addEventListener('click', () => {
          try {
            const selectedUrl = option.dataset.url;
            selected.textContent = option.textContent;
            options.style.display = 'none';
  
            optionItems.forEach(o => o.classList.remove('selected'));
            option.classList.add('selected');
  
            filterLinks.forEach(link => {
              link.classList.toggle('active', link.dataset.href === selectedUrl);
            });
  
            window.location.href = selectedUrl;
          } catch (err) {
            console.error('Error handling option click:', err);
          }
        });
      });
  
      filterLinks.forEach(link => {
        link.addEventListener('click', e => {
          e.preventDefault();
          try {
            const selectedUrl = link.dataset.href;
            const matchingOption = Array.from(optionItems).find(o => o.dataset.url === selectedUrl);
  
            if (matchingOption) {
              selected.textContent = matchingOption.textContent;
  
              optionItems.forEach(o => o.classList.remove('selected'));
              matchingOption.classList.add('selected');
            }
  
            filterLinks.forEach(l => l.classList.remove('active'));
            link.classList.add('active');
  
            window.location.href = selectedUrl;
          } catch (err) {
            console.error('Error handling filter link click:', err);
          }
        });
      });
  
      document.addEventListener('click', (e) => {
        try {
          if (!dropdown.contains(e.target)) {
            options.style.display = 'none';
          }
        } catch (err) {
          console.error('Error handling outside click:', err);
        }
      });
    }
  } catch (err) {
    console.error('Error initializing dropdown:', err);
  }
  
  try {
    document.addEventListener('change', function (event) {
      if (event.target.matches('.accept-terms')) {
        const checkbox = event.target;
        const checkoutButtons = document.querySelectorAll('.cart__checkout-button');

        if (checkoutButtons.length) {
          checkoutButtons.forEach(button => {
            if (checkbox.checked) {
              button.removeAttribute('disabled');
            } else {
              button.setAttribute('disabled', 'disabled');
            }
          });
        } else {
          console.warn('No checkout buttons found in the DOM.');
        }
      }
    });
  } catch (err) {
    console.error('Error initializing checkbox logic:', err);
  }

});

function matchHeight(selector) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  elements.forEach(el => {
    el.style.height = 'auto';
  });

  requestAnimationFrame(() => {
    let maxHeight = 0;

    elements.forEach(el => {
      const height = el.getBoundingClientRect().height;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    elements.forEach(el => {
      el.style.height = `${maxHeight}px`;
    });
  });
}

function initMatchHeight() {
  matchHeight('.section-featured-collection .featured-collection .product-grid .grid__item .card-wrapper .card__content .card__heading');
  matchHeight('.add__address--content');
}

document.addEventListener('DOMContentLoaded', initMatchHeight);
window.addEventListener('load', initMatchHeight);
window.addEventListener('resize', () => {
  clearTimeout(window._mhTimer);
  window._mhTimer = setTimeout(initMatchHeight, 100);
});



// // Wait until the DOM is fully loaded
// document.addEventListener("DOMContentLoaded", function() {
//   // Select all elements with the class .categories__filter--list-icon
//   document.querySelectorAll('.categories__filter--list-icon').forEach(function(icon) {
//     icon.addEventListener('click', function(e) {
//       e.preventDefault(); 
//       // Find the closest parent with class .categories__filter--list and toggle 'toggled' class
//       var parentLi = icon.closest('.categories__filter--list');
//       if (parentLi) {
//         parentLi.classList.toggle('toggled');
//       }
//     });
//   });
// });


document.addEventListener('DOMContentLoaded', function () {
  // --- Sub-category accordion (desktop + mobile, both work independently) ---
  document.querySelectorAll('.categories__filter--list-icon').forEach(function (icon) {
    let submenu = icon.nextElementSibling;
    while (submenu && submenu.tagName.toLowerCase() !== 'ul') {
      submenu = submenu.nextElementSibling;
    }

    const parentItem = icon.closest('.categories__filter--list-child');

    if (submenu && parentItem) {
      const initiallyOpen = submenu.style.display === 'block';
      parentItem.classList.toggle('categories__filter--list-open', initiallyOpen);
    }

    icon.addEventListener('click', function (e) {
      e.preventDefault();

      if (submenu) {
        const isOpen = submenu.style.display === 'block';
        submenu.style.display = isOpen ? 'none' : 'block';

        icon.classList.toggle('toggled', !isOpen);

        if (parentItem) {
          parentItem.classList.toggle('categories__filter--list-open', !isOpen);
        }
      }
    });
  });

  // --- Mobile "Categories" accordion toggle ---
  document.querySelectorAll('.categories__filter-mobile--toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const content = toggle.nextElementSibling;
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', String(!isOpen));
      toggle.classList.toggle('is-open', !isOpen);
      content.style.display = isOpen ? 'none' : 'block';
    });
  });
});

// --- International shipping message ---
(function () {
  try {
    console.log('[shipping-script] block reached inside custom.js');

    function initShippingCheck() {
      const shippingMessages = document.querySelectorAll('.international-shipping-message');
      if (!shippingMessages.length) {
        console.error('[shipping-script] no elements found');
        return;
      }
      console.log('[shipping-script] found', shippingMessages.length, 'elements');

      fetch('https://ipapi.co/json/')
        .then(function (response) {
          if (!response.ok) throw new Error('Primary API failed: ' + response.status);
          return response.json();
        })
        .then(function (data) {
          handleResult(data.country_code, shippingMessages);
        })
        .catch(function (err) {
          console.warn('[shipping-script] primary failed, trying fallback:', err);
          fetch('https://ipwho.is/')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              handleResult(data.country_code, shippingMessages);
            })
            .catch(function (fallbackErr) {
              console.error('[shipping-script] fallback failed too:', fallbackErr);
              shippingMessages.forEach(function (el) {
                el.style.setProperty('display', 'block', 'important');
              });
            });
        });
    }

    function handleResult(countryCode, elements) {
      console.log('[shipping-script] country:', countryCode);
      elements.forEach(function (el) {
        if (countryCode === 'US') {
          el.style.setProperty('display', 'none', 'important');
        } else {
          el.style.setProperty('display', 'block', 'important');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initShippingCheck);
    } else {
      initShippingCheck();
    }
  } catch (e) {
    console.error('[shipping-script] unexpected error:', e);
  }
})();

document.querySelectorAll('.video-section-over-button a.button.button--primary').forEach(function(button) {
  button.addEventListener('click', function(e) {
    e.preventDefault();

    const target = document.querySelector(this.getAttribute('href'));

    if (target) {
      const offset = 80;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  });
});